import api from '@/libs/axiosInstance';
import type { ApiResponse } from '@fluenceur/types';
import {
  BRAND_SPACE_HOME_API_PATH,
  type BrandSpaceHomeResponse,
} from '@fluenceur/types/brand-space';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

export const brandSpaceHomeQueryKey = (brandId: string | null) =>
  ['brand-space', 'home', brandId] as const;

export async function fetchBrandSpaceHome(): Promise<BrandSpaceHomeResponse> {
  const response = await api.get<ApiResponse<BrandSpaceHomeResponse>>(BRAND_SPACE_HOME_API_PATH);
  if (!response.data.data) {
    throw new Error(response.data.message || 'Brand Space Home is unavailable.');
  }
  return response.data.data;
}

export function useBrandSpaceHomeQuery(
  brandId: string | null
): UseQueryResult<BrandSpaceHomeResponse, Error> {
  return useQuery<BrandSpaceHomeResponse, Error>({
    queryKey: brandSpaceHomeQueryKey(brandId),
    queryFn: fetchBrandSpaceHome,
    enabled: Boolean(brandId),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
